export default "__VITE_ASSET__Cwzj6RnO__"